<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
    <div class="max-w-md w-full space-y-8">
      <div>
        <div class="flex justify-center">
          <img class="h-12 w-auto" src="/logo-mifo.svg" alt="MIFO Logo" />
        </div>
        <h2 class="mt-6 text-center text-3xl font-heading font-bold text-mifo-primary">
          Anmeldung
        </h2>
        <p class="mt-2 text-center text-sm text-gray-600">
          MIFO Inventory Manager
        </p>
      </div>
      
       <form class="mt-8 space-y-6" @submit.prevent="step === 1 ? handleLogin() : handleVerify2FA()">
        <div class="rounded-md shadow-sm -space-y-px">
          <div v-if="step === 1">
            <label for="username" class="sr-only">Benutzername</label>
            <input
              id="username"
              v-model="form.username"
              name="username"
              type="text"
              required
              class="input-field rounded-t-lg"
              placeholder="Benutzername"
            />
          </div>
          <div v-if="step === 1">
            <label for="password" class="sr-only">Passwort</label>
            <input
              id="password"
              v-model="form.password"
              name="password"
              type="password"
              required
              class="input-field rounded-b-lg"
              placeholder="Passwort"
            />
          </div>
          <div v-if="step === 2">
            <label for="code" class="sr-only">2FA Code</label>
            <input
              id="code"
              v-model="form.code"
              name="code"
              inputmode="numeric"
              pattern="[0-9]*"
              maxlength="6"
              minlength="6"
              type="text"
              required
              class="input-field rounded-lg"
              placeholder="6-stelliger 2FA Code"
            />
          </div>
        </div>

        <div v-if="error" class="text-red-600 text-sm text-center">
          {{ error }}
        </div>

        <div>
          <button
            type="submit"
            :disabled="loading"
            class="btn-primary w-full flex justify-center py-2 px-4"
          >
            <span v-if="loading" class="flex items-center">
              <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              {{ step === 1 ? 'Anmeldung läuft...' : 'Überprüfung...' }}
            </span>
            <span v-else>{{ step === 1 ? 'Anmelden' : 'Bestätigen' }}</span>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from 'vue'
import { useRouter } from 'vue-router'
import axios from 'axios'

export default {
  name: 'Login',
  setup() {
    const router = useRouter()
    const loading = ref(false)
    const step = ref(1)
    const preAuthToken = ref('')
    const error = ref('')
    
    const form = reactive({
      username: '',
      password: '',
      code: ''
    })

    const handleLogin = async () => {
      loading.value = true
      error.value = ''
      
      try {
        const response = await axios.post('/api/auth/login', { username: form.username, password: form.password })
        if (response.data.twoFactorRequired && response.data.preAuthToken) {
          preAuthToken.value = response.data.preAuthToken
          step.value = 2
        } else if (response.data.success && response.data.token) {
          localStorage.setItem('auth_token', response.data.token)
          router.push('/herzbeben/courses')
        } else {
          error.value = response.data.message || 'Anmeldung fehlgeschlagen'
        }
      } catch (err) {
        error.value = err.response?.data?.message || 'Anmeldung fehlgeschlagen'
      } finally {
        loading.value = false
      }
    }

    const handleVerify2FA = async () => {
      loading.value = true
      error.value = ''
      try {
        const response = await axios.post('/api/auth/verify-2fa', { code: form.code, preAuthToken: preAuthToken.value })
        if (response.data.success && response.data.token) {
          localStorage.setItem('auth_token', response.data.token)
          router.push('/herzbeben/courses')
        } else {
          error.value = response.data.message || '2FA fehlgeschlagen'
        }
      } catch (err) {
        error.value = err.response?.data?.message || '2FA fehlgeschlagen'
      } finally {
        loading.value = false
      }
    }

    return {
      form,
      loading,
      error,
      step,
      handleLogin,
      handleVerify2FA
    }
  }
}
</script> 